import { createBrowserHistory } from 'history'

// в дальнейшем можно кастомить навигацию, например добавить отслеживание глубины роутов
export function createAppHistory() {
  return createBrowserHistory()
}